const truncate = (string = "", length = 30) => {
  if(typeof string === 'string' || string instanceof String) {
    return string.length > length ? `${string.slice(0,length - 3)}...` : string
  }
  return null;
}

export default truncate;